import React, { useEffect, useState } from "react";
import { InputText } from 'primereact/inputtext';
import { Panel } from 'primereact/panel';

import ProCalendar from "../../components/common/ProCalendar";
import ProMultiSelect from "../../components/common/ProMultiSelect";
import ProAttendanceFilter from "../../components/attendance/ProAttendanceFilter";
import ProTreeTable from "../../components/common/ProTreeTable";

import useAttendance from "../../hooks/useAttendance";
import useTreeTemplateServices from "../../hooks/useTreeTemplateServices";
import { useHierarchyService } from "../../hooks/useHierarchyService";
import { useLocationServices } from "../../hooks/useLocationServices";

import { GetISODate, GetStartOfDay } from "../../utilities/DateHelper";
import _ from 'lodash'

const Attendance = ()=>{
    const [searchValue, setSearchValue] = useState("");
    const [showFilter, setShowFilter] = useState(false);
    const { isLocationsInitialized, locations, primaryLocationId } = useLocationServices();
    const { data:{ filter, isFilterApplied, selectedLocations, defaultExpandedKeys }, 
    actions:{InitializeDefaults, SetSelectedLocations, SetSelectedDate } } = useAttendance({ refreshTree: true });
    const { data:{tree}} =  useHierarchyService()

    useEffect(() => {
        if (_.get(locations, "length") > 0) {
            if(_.isNull(selectedLocations)){
                InitializeDefaults(_.isNull(filter.date)?GetISODate(GetStartOfDay()) : filter.date, locations)   
            }       
           
        }
    }, [InitializeDefaults, selectedLocations, locations, primaryLocationId, filter])

 
    const performAction = ()=>{

    }

    const onDateChanged = (e) => {
        var formattedDate = GetISODate(e.value)      
        SetSelectedDate(formattedDate)
    }
    const toggleFilter = () => {
        setShowFilter(prev => !prev)
    }
    const {data:{AttendanceTableConfig}, actions :{OnTreeNodeSelect}} = useTreeTemplateServices({performAction, activePage:"ATTENDANCE"}); 

    return <div>
            <div className='header-row'>           
            <div className="search-box">
                <span className="p-input-icon-left">
                    <i className="pi pi-search" />
                    <InputText className='search-bar-input' onChange={(e) => setSearchValue(e.target.value)} placeholder="Search" />
                </span>
            </div> 
            <div>
                <ProMultiSelect value={selectedLocations} options={locations} onChange={SetSelectedLocations}/>
            </div>          
            <div className='header-filter-box' onClick={() => setShowFilter(prev => !prev)}>
                <span style={{ marginRight: "5px" }}> Filter</span>
                {isFilterApplied && <i className="fa fa-filter margin-top-4"></i>}
                {!isFilterApplied && <i className="fal fa-filter margin-top-4"></i>}
            </div>
            <div className='attendance-calendar' >
                <ProCalendar id="attendanceDate"
                    placeholder="Date"
                    value={filter.date}
                    onChange={onDateChanged}
                    style={{ width: "100%", marginBottom: "2px", height: "40px" }} 
                    maxDate= {GetISODate(new Date())}                   
                    required />
            </div>
        </div>
        {showFilter && <div className="p-col-16 p-lg-12">
            <Panel header="Filter Options">
                <ProAttendanceFilter toggleFilter={toggleFilter} />
            </Panel>
        </div>}
        <div>
          
        </div>
        <div>
            <div className='data-row'>                
                <div className="p-col-16 p-lg-12">
                    {(tree && tree.length > 0) && <ProTreeTable index={1} treeData={tree} defaultSelectionKey={tree[0].key} defaultExpandedKeys={defaultExpandedKeys} isFilterApplied={isFilterApplied} searchValue={searchValue} config={AttendanceTableConfig} OnTreeNodeSelect={OnTreeNodeSelect}  />}                   
                    {(isLocationsInitialized && _.get(selectedLocations, "length") === 0) && <div>No Records found</div>}
                </div>
            </div>
        </div>       
    </div>
  
}

export default Attendance;

